class CompareProducts extends HTMLElement {
  constructor() {
    super(); // Always call super in a custom element's constructor
  
  }
  connectedCallback() {
    requestAnimationFrame(() => this.initCard());
  }
  initCard(){
      this.fetchURLs = [];
    this.comparable_products = this.querySelectorAll(".compare-checkbox");
    this.finalData = {};
    this.table_template = "";
    this.debouncer = null;
    this.sectionId = this.dataset.sectionId
    this.compareCount = document.querySelector(".compare-product-number."+this.dataset.sectionId);
    this.compareButton = document.querySelector(".compare-button."+this.sectionId);
    document.querySelector(".compare-button."+this.sectionId).addEventListener("click",this.debouncing.bind(this));
    document.querySelector(".specification-table").querySelector(".close-button").addEventListener("click",this.closePopup.bind(this) )
  }

  debouncing(){
    if(this.debouncer){
      clearTimeout(this.debouncer)
    }
    this.debouncer = setTimeout(this.URLCalls.bind(this))
  }

  closePopup(){
    this.fetchURLs = [];
    document.querySelector(".specification-table").style.display = "none";
    document.querySelector("body").style.overflow = "unset";
  }

  uncheck(){
    window.input_section = []
    this.querySelectorAll("compare-input").forEach(ele =>{
      ele.querySelector("input").checked = false
      ele.querySelector('label').innerText = 'Compare'
      ele.querySelector('label').innerText = 'Compare'
    })
  }

  removeAllCompareProducts(){
    this.uncheck();
    window.input_section = [];
    this.updateCompareCount();
  }

  removeAllCompareProducts(){
    this.uncheck();
    window.input_section = [];
    this.updateCompareCount();
  }

  URLCalls() {    
    this.comparable_products = this.querySelectorAll(".compare-checkbox");
    const checkedProducts = Array.from(this.comparable_products)
    const urlArr = checkedProducts
      .map(item => 
        item.checked ? `/products/${item.dataset.productHandle}?view=alternate&variant=${item.dataset.variantId}&section=product-details` : null
      )
      .filter(url => url !== null); // Filter out null values
      this.fetchURLs = urlArr
      this.calls(urlArr)
  }

  async calls(urlArr=[] , popup_close = false){
    try {
      if(urlArr.length < 2 && !popup_close ){
        alert("Add atleast two products to compare");
        return;
      }
      document.querySelector(".loader-container").classList.remove("hidden")
      const promises = urlArr.map(async (url) => {
        const res = await fetch(url);
        const data = await res.text();
        const html = new DOMParser().parseFromString(data, "text/html");
        const specificationArray = JSON.parse(html.querySelector("#compare-product-details").innerHTML);
        const name = html.querySelector("#name").innerText;
        const img_url = html.querySelector("#image-url").innerText;
        const product_price = html.querySelector("#product-price").innerText;
        const product_url = html.querySelector("#product-url").innerText;
        const product_handle = html.querySelector("#handle").innerText;
        const product_feature = html.querySelector("#product-feature").innerText;
        console.log(product_feature.trim().split(`\n`).map(text => text.trim()).join(", "))
        specificationArray.push(`_product_name || ${name.trim()}`);
        specificationArray.push(`_image_url || ${img_url.trim()}`);
        specificationArray.push(`_product_url || ${product_url.trim()}`);
        specificationArray.push(`_price || ${product_price.trim()}`);
        specificationArray.push(`_product_hanlde || ${product_handle.trim()}`);
        specificationArray.push(`_product_feature || ${product_feature.trim().split(`\n`).map(text => text.trim()).join(", ")}`)
        return specificationArray; // Return the parsed specificationArray for further processing
      });

      // Wait for all fetch calls to resolve
      const results = await Promise.all(promises);
      this.finalData = {}
      results.forEach((specificationArray, index) => {
        specificationArray.forEach((val) => {
          const valArr = val.split("||");
          const key = valArr[0].trim();
          const value = valArr[1].trim();
          const obj = {};
          obj[index] = value;
          if (!this.finalData[key]) {
            this.finalData[key] = {};
          }
          this.finalData[key][index] = value;
        });
      });
      this.showPopUp(urlArr);
      document.querySelector(".loader-container").classList.add("hidden")
    } catch (error) {
      document.querySelector(".loader-container").classList.add("hidden")
      console.error("Error in fetching data:", error);
    }
  }
  
  showPopUp(urlArr){
    let theadData = '';

    for (const [key, value] of Object.entries(this.finalData['_product_name'] || {})) {
      theadData = theadData + `<div class="isolate table-col data-col-index-${key}" data-index=${key}>
                                <span class="compare-item-remove" data-url=${urlArr[key]} id="${this.finalData['_product_hanlde'][key]}">X</span>
                                <a href="${this.finalData['_product_url'][key]}">
                                <img class="table-image" src=${this.finalData['_image_url'][key]} height="auto" width="200">
                                </a>
                                <a href="${this.finalData['_product_url'][key]}" class="table-pd-title">${value}</a>
                              </div>`;
    }

    theadData = `<div class="col-grid t-head table-rows col-${urlArr.length}">${theadData}</div>`


    let price_col_str = ''
    let product_feature_col = ''
    let button_str = ''
    let col_flag = true;
    for(let i=0;i<urlArr.length;i++ ){
      price_col_str += `<div class="table-col data-col-index-${i}" data-inner-index=${i}>${this.finalData['_price'][i]?this.finalData['_price'][i]:"----"}</div>`
      product_feature_col += `<div class="table-col data-col-index-${i}" data-inner-index=${i}>${this.finalData['_product_feature'][i]?this.finalData['_product_feature'][i]:"----"}</div>`
      if(col_flag){
        col_flag =   this.finalData['_product_feature'][i] ? false : true 
      }
      button_str += `<div class="table-button-wrapper"><a href="${this.finalData['_product_url'][i]}" class="button button--primary">Shop Now</a></div>`
    }

    
    price_col_str = `<details open>
      <summary>Price</summary>
      <div class="col-grid table-rows col-${urlArr.length}">${price_col_str}</div>
      </details>`;

    product_feature_col = `<details open>
      <summary>Product Feature</summary>
      <div class="col-grid table-rows col-${urlArr.length}">${product_feature_col}</div>
      </details>`;

    price_col_str = col_flag ? price_col_str : price_col_str + product_feature_col
    

    button_str = `<div class="col-grid sticky-text table-rows col-${urlArr.length}">${button_str}</div>`


    let row = "";
    for(const [key, value] of Object.entries(this.finalData)){
      if( key.includes("Manufactured") || key.startsWith("_") || key.includes("Marketed")){
        continue;
      }
      let col_str = ""
      for(let i=0;i<urlArr.length;i++ ){
        col_str += `<div class="table-col data-col-index-${i}" data-inner-index=${i}>${value[i]?value[i]:"----"}</div>`
      }
      row = row + `<details open>
      <summary>${key}</summary>
      <div class="col-grid table-rows col-${urlArr.length}">${col_str}</div>
      </details>`;
    }

    this.table_template = theadData + button_str + `<div class="scroll-cont">`+ price_col_str + row + `</div>`;
    document.querySelector(".specification-table").style.display = "block";
    document.querySelector("body").style.overflow = "hidden";
    document.querySelector(".specification-table").querySelector(".table-container").innerHTML = this.table_template;
    document.querySelectorAll(".compare-item-remove").forEach((ele) => {
      ele.addEventListener('click', this.hydrateRemove.bind(this))
    })
  }

  hydrateRemove(e){
    let xclude_url = e.target.dataset.url
    let updated_url_arr = this.fetchURLs.filter(urls => urls !== xclude_url) 
    this.fetchURLs = updated_url_arr
    let inputs = document.querySelectorAll(`.compare-section [data-input-am="${e.target.id}"]`);
    
    console.log("inputs", inputs)
    inputs.forEach((input) => {
      input.checked = false
    });
    window.input_section.pop();
    this.updateCompareCount();
    if (!updated_url_arr.length) {
      this.fetchURLs = [];
      document.querySelector(".specification-table").style.display = "none";
      document.querySelector("body").style.overflow = "unset";
      return;
    }
    this.calls(updated_url_arr, true);
  }

  updateCompareCount() {
    if(window.input_section.length){
      this.compareCount.innerHTML = `(${window.input_section.length})`;
    }else{
      this.compareButton.style.display = window.input_section.length ? "table" : "none";
    }
  }
}

customElements.define("compare-product", CompareProducts);

document.addEventListener("DOMContentLoaded",function(){
  window.removeAllCompareProducts = ()=>{
    let CompareProductElm = document.querySelectorAll('compare-product') 
    CompareProductElm?.forEach((elm)=>{
      elm?.removeAllCompareProducts();
    })
  }
})

